export enum ChatMessageType {
    TEXT = 0,
    FILE = 1,
    VOICE = 2,
    APPLICATION_UPDATE = 3,
    CALL = 4,
}

export enum ChatMessageSenderType {
    SYSTEM = 0,
    PARTNER = 1,
    WORKER = 2,
}